import React, { useEffect, useState } from 'react';
import ResultsChart from '../components/results/ResultsChart';
import { useNavigate } from 'react-router-dom';
import Header from '../components/common/Header';
import Button from '../components/common/Button';
import { useLocation } from 'react-router-dom';
import useScrollToTop from '../hooks/hook';
import { api } from '../config';
import Spinner from '../components/common/Spinner';
import Footer from '../components/common/Footer';
import { useError, withErrorHandling } from '../components/common/ErrorHandling';

const ResultsPage: React.FC = () => {
    const [loading, setLoading] = useState(true); // ローディング状態の管理
    const location = useLocation();
    const { userId } = location.state || {};
    const [individualResults, setIndividualResults] = useState<number[]>([]);
    const [overallResults, setOverallResults] = useState<number[]>([]);
    const [commentResults, setCommentResults] = useState<string[]>([]);

    const { setError } = useError();
    const navigate = useNavigate();
    useScrollToTop();

    const handleContactClick = () => {
        sessionStorage.setItem('userId', userId);
        sessionStorage.setItem('results', JSON.stringify({
            individualResults,
            overallResults,
            commentResults
        }));
        navigate(`/contact`);
    };

    useEffect(() => {
        const fetchResults = async () => {
            try {
                const response = await api.postResults(userId);

                setIndividualResults(response.individualResults);
                setOverallResults(response.overallResults);
                setCommentResults(response.comments);
                setLoading(false);
            } catch (error) {
                setError('アンケート結果の取得中に問題が発生しました。再読み込みしてください。');
                setLoading(false);
            }
        };

        fetchResults();
    }, [userId]);

    const summary = {
        score: {
            'しなやかに学び続ける力': individualResults[2],
            '自分と他者を等しく尊重する力': individualResults[0],
            '人生を肯定する力': individualResults[3],
            '快適なコミュニケーションを図る力': individualResults[1],
        },
        average: {
            'しなやかに学び続ける力': overallResults[2],
            '自分と他者を等しく尊重する力': overallResults[0],
            '人生を肯定する力': overallResults[3],
            '快適なコミュニケーションを図る力': overallResults[1],
        }
    };

    // const summary = {
    //     score: {
    //         '自分と他者を等しく尊重する力': individualResults[0],
    //         '快適なコミュニケーションを図る力': individualResults[1],
    //         'しなやかに学び続ける力': individualResults[2],
    //         '人生を肯定する力': individualResults[3],
    //     },
    //     average: {
    //         '自分と他者を等しく尊重する力': overallResults[0],
    //         '快適なコミュニケーションを図る力': overallResults[1],
    //         'しなやかに学び続ける力': overallResults[2],
    //         '人生を肯定する力': overallResults[3],
    //     }
    // };

    return (
        <div className="l_container">
            {loading ? (
                <Spinner />
            ) : (
                <>
                    <Header />
                    <div className="l_results-page">
                        <p className="results-subtitle">挑戦力診断結果</p>
                        <div id="chart-container">
                            <ResultsChart data={summary} />
                            <div className="l_results-description">
                                <p>診断コメント</p>
                                {commentResults.map((comment, index) => (
                                    <span key={index}>{comment}</span>
                                ))}
                            </div>
                        </div>
                        <div className="results_page_watare">
                            <Button onClick={handleContactClick} className="contact-button custom" iconPosition="right"
                                iconType="right"
                                iconSize={30}>
                                ご感想をお聞かせください
                            </Button>
                        </div>
                    </div>
                    <Footer />
                </>
            )}
        </div>
    );
}

export default ResultsPage;
